/* Fastline landing — vanilla JS (no React/bundlers). Scoped to [data-fl-root]. */
(function(){
  function initInstance(root){
    var header = root.querySelector('[data-fl-header]') || root.querySelector('#fl-main-nav');
    var hamburger = root.querySelector('[data-fl-hamburger]') || root.querySelector('.fl-nav-burger');
    var mobileMenu = root.querySelector('[data-fl-mobile-menu]') || root.querySelector('.fl-nav-mobile-menu');

    /* ---- 1. Scroll State on Navbar ---- */
    function onScroll(){
      if(!header) return;
      if(window.scrollY > 20) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    }
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();

    /* ---- 2. Mobile Menu ---- */
    if(hamburger && mobileMenu){
      hamburger.addEventListener('click', function(e){
        e.preventDefault();
        mobileMenu.classList.toggle('is-open');
      });
      mobileMenu.querySelectorAll('a').forEach(function(a){
        a.addEventListener('click', function(){ mobileMenu.classList.remove('is-open'); });
      });
    }

    /* ---- 3. Cart Gestor & Section Rendering API (Clonado de FV) ---- */
    function getFLCart() {
      return fetch('/cart.js').then(function(res) {
        if (!res.ok) throw new Error('Error al obtener el carrito');
        return res.json();
      });
    }

    function syncFLAllCartCounters(cart) {
      var count = cart.item_count;
      var countEls = document.querySelectorAll('[data-fl-cart-count], [data-fl-cart-count-badge], .fl-cart-count');
      countEls.forEach(function(el) {
        el.textContent = count;
        if (el.classList.contains('fl-cart-count')) {
          el.style.display = count > 0 ? 'flex' : 'none';
        }
      });
    }

    function refreshFLCartDrawer() {
      return getFLCart().then(function(cart) {
        syncFLAllCartCounters(cart);

        var sectionEl = root.hasAttribute('data-section-id') ? root : root.querySelector('[data-section-id]');
        var sectionId = sectionEl ? (sectionEl.getAttribute('data-section-id') || sectionEl.getAttribute('id')) : null;
        
        if (sectionId && sectionId.includes('fl-section-')) {
          sectionId = sectionId.replace('fl-section-', '');
        }

        var url = window.location.pathname;
        if (sectionId) {
          url += '?section_id=' + sectionId;
        }

        return fetch(url)
          .then(function(res) { return res.text(); })
          .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            var newDrawer = doc.querySelector('[data-fl-cart-drawer]');
            var currentDrawer = root.querySelector('[data-fl-cart-drawer]');

            if (currentDrawer && newDrawer) {
              var isOpen = currentDrawer.classList.contains('is-open');
              currentDrawer.innerHTML = newDrawer.innerHTML;
              if (isOpen) {
                currentDrawer.classList.add('is-open');
              }
            }
          });
      });
    }

    /* Evento global para escuchar cambios desde otros scripts */
    document.addEventListener('cart:refresh', refreshFLCartDrawer);

    /* ---- 4. Animated Monitor (Hero) ---- */
    root.querySelectorAll('[data-fl-monitor]').forEach(function(mon){
      var countEls = mon.querySelectorAll('[data-fl-campo-count]');
      var barEls = mon.querySelectorAll('[data-fl-campo-bar]');
      var colabEls = mon.querySelectorAll('[data-fl-colab-count]');
      var campoCount = 0, colabCount = 0;
      setInterval(function(){
        campoCount = campoCount >= 5 ? 0 : campoCount + 1;
        var pct = (campoCount/5)*100;
        countEls.forEach(function(el){ el.textContent = campoCount; });
        barEls.forEach(function(el){ el.style.width = pct + '%'; });
      }, 700);
      setInterval(function(){
        colabCount = colabCount >= 1284 ? 0 : colabCount + 43;
        var shown = Math.min(colabCount, 1284).toLocaleString('es-MX');
        colabEls.forEach(function(el){ el.textContent = shown; });
      }, 120);
    });

    /* ---- 5. Quiz ---- */
    var quiz = root.querySelector('[data-fl-quiz]');
    if(quiz){
      var state = { step:0, sector:'', size:'', frequency:'' };
      var panels = quiz.querySelectorAll('[data-fl-quiz-panel]');
      var stepStrip = quiz.querySelector('[data-fl-quiz-stepstrip]');
      var stepNodes = quiz.querySelectorAll('[data-fl-step-node]');

      function renderStep(){
        panels.forEach(function(p){
          p.classList.toggle('is-active', Number(p.getAttribute('data-fl-quiz-panel')) === state.step);
        });
        if(stepStrip) stepStrip.classList.toggle('is-visible', state.step > 0 && state.step < 4);
        stepNodes.forEach(function(node){
          var idx = Number(node.getAttribute('data-fl-step-node'));
          var circle = node.querySelector('[data-fl-step-circle]');
          var label = node.querySelector('[data-fl-step-name]');
          var bar = node.querySelector('[data-fl-step-bar]');
          if(state.step > idx){
            if(circle){ circle.style.background = '#47c1c5'; circle.textContent = '✓'; }
            if(label) label.style.color = '#47c1c5';
            if(bar) bar.style.background = '#47c1c5';
          } else if(state.step === idx){
            if(circle){ circle.style.background = '#0D0D0D'; circle.textContent = String(idx); }
            if(label) label.style.color = '#0D0D0D';
            if(bar) bar.style.background = 'rgba(0,0,0,0.06)';
          } else {
            if(circle){ circle.style.background = 'rgba(0,0,0,0.07)'; circle.textContent = String(idx); }
            if(label) label.style.color = '#CCC';
            if(bar) bar.style.background = 'rgba(0,0,0,0.06)';
          }
        });
      }

      quiz.addEventListener('click', function(e){
        var startBtn = e.target.closest('[data-fl-quiz-start]');
        if(startBtn){ state.step = 1; renderStep(); return; }

        var backTo = e.target.closest('[data-fl-quiz-back]');
        if(backTo){ state.step = Number(backTo.getAttribute('data-fl-quiz-back')); renderStep(); return; }

        var reset = e.target.closest('[data-fl-quiz-reset]');
        if(reset){ state = {step:0, sector:'', size:'', frequency:''}; renderStep(); return; }

        var sectorBtn = e.target.closest('[data-fl-sector-opt]');
        if(sectorBtn){
          state.sector = sectorBtn.getAttribute('data-fl-sector-opt');
          state.step = 2;
          renderStep();
          return;
        }
        var sizeBtn = e.target.closest('[data-fl-size-opt]');
        if(sizeBtn){
          state.size = sizeBtn.getAttribute('data-fl-size-opt');
          state.step = 3;
          renderStep();
          return;
        }
        var freqBtn = e.target.closest('[data-fl-freq-opt]');
        if(freqBtn){
          state.frequency = freqBtn.getAttribute('data-fl-freq-opt');
          state.step = 4;
          computeResult();
          renderStep();
          return;
        }
      });

      function computeResult(){
        var hazardSectors = ['Construcción','Oil & Gas','Minería'];
        var bigSizes = ['Más de 500','200 – 500'];
        var group = 'default';
        if(hazardSectors.indexOf(state.sector) !== -1) group = 'hazard';
        else if(bigSizes.indexOf(state.size) !== -1) group = 'volume';

        var resultBlock = quiz.querySelector('[data-fl-quiz-result="'+group+'"]');
        quiz.querySelectorAll('[data-fl-quiz-result]').forEach(function(b){ b.style.display = 'none'; });
        if(resultBlock) resultBlock.style.display = 'block';

        var sectorOut = quiz.querySelector('[data-fl-out-sector]');
        var sizeOut = quiz.querySelector('[data-fl-out-size]');
        var freqOut = quiz.querySelector('[data-fl-out-freq]');
        if(sectorOut) sectorOut.textContent = state.sector;
        if(sizeOut) sizeOut.textContent = state.size;
        if(freqOut) freqOut.textContent = state.frequency.split(' ')[0];
      }

      renderStep();
    }

    /* ---- 6. Catalog: Steppers + Add to Cart ---- */
    root.querySelectorAll('[data-fl-product-card]').forEach(function(card){
      var qtyEl = card.querySelector('[data-fl-qty]');
      var minus = card.querySelector('[data-fl-qty-minus]');
      var plus = card.querySelector('[data-fl-qty-plus]');
      var addBtn = card.querySelector('[data-fl-add-cart]');
      var variantId = card.getAttribute('data-fl-variant-id');

      function getQty(){ return Math.max(1, parseInt(qtyEl.textContent, 10) || 1); }
      if(minus) minus.addEventListener('click', function(){ qtyEl.textContent = Math.max(1, getQty()-1); });
      if(plus) plus.addEventListener('click', function(){ qtyEl.textContent = getQty()+1; });

      if(addBtn && variantId){
        addBtn.addEventListener('click', function(){
          var qty = getQty();
          fetch('/cart/add.js', {
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body: JSON.stringify({ items:[{ id: variantId, quantity: qty }] })
          }).then(function(res){
            if(!res.ok) throw new Error('cart add failed');
            return refreshFLCartDrawer();
          }).then(function(){
            addBtn.classList.add('is-added');
            addBtn.textContent = 'Agregado';
            var cartDrawer = root.querySelector('[data-fl-cart-drawer]');
            if (cartDrawer) {
              cartDrawer.classList.add('is-open');
            }
            setTimeout(function(){
              addBtn.classList.remove('is-added');
              addBtn.textContent = 'Agregar';
            }, 1500);
          }).catch(function(err){
            console.error('Fastline: error al agregar al carrito', err);
          });
        });
      }
    });

    /* ---- 7. Quiz Add to Cart Buttons ---- */
    root.querySelectorAll('[data-fl-quiz-add]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var variantId = btn.getAttribute('data-fl-quiz-add');
        if(!variantId) return;
        fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ items:[{ id: variantId, quantity: 1 }] })
        }).then(function(res){ if(!res.ok) throw new Error('cart add failed'); return refreshFLCartDrawer(); })
          .then(function(){
            var label = btn.getAttribute('data-fl-added-label') || 'Agregado';
            btn.textContent = label;
            var cartDrawer = root.querySelector('[data-fl-cart-drawer]');
            if (cartDrawer) {
              cartDrawer.classList.add('is-open');
            }
          }).catch(function(err){ console.error('Fastline: error al agregar al carrito', err); });
      });
    });

    /* ---- 8. Delegación de Clics para el Carrito (Abrir, Cerrar, +, -, Quitar) ---- */
    root.addEventListener('click', function(e) {
      // Toggle abrir/cerrar drawer
      var cartToggle = e.target.closest('[data-fl-cart-toggle]');
      if (cartToggle) {
        e.preventDefault();
        e.stopPropagation();
        var cartDrawer = root.querySelector('[data-fl-cart-drawer]');
        if (cartDrawer) {
          cartDrawer.classList.toggle('is-open');
        }
        return;
      }

      // Cerrar clic fuera
      var cartWrap = root.querySelector('.fl-cart-wrap');
      var cartDrawerEl = root.querySelector('[data-fl-cart-drawer]');
      if (cartDrawerEl && cartDrawerEl.classList.contains('is-open')) {
        if (cartWrap && !cartWrap.contains(e.target)) {
          cartDrawerEl.classList.remove('is-open');
        }
      }

      // Modificar cantidad dentro del drawer
      var lineItem = e.target.closest('[data-fl-cart-line]');
      if (lineItem) {
        var key = lineItem.getAttribute('data-key');
        var qtySpan = lineItem.querySelector('.fl-cart-line-qty span');
        var currentQty = parseInt(qtySpan ? qtySpan.textContent.trim() : '1', 10);
        var newQty = currentQty;

        if (e.target.closest('[data-fl-qty-increase]')) {
          newQty = currentQty + 1;
        } else if (e.target.closest('[data-fl-qty-decrease]')) {
          newQty = Math.max(0, currentQty - 1);
        } else if (e.target.closest('[data-fl-cart-remove]')) {
          newQty = 0;
        } else {
          return;
        }

        e.preventDefault();

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        })
        .then(function (res) {
          if (!res.ok) throw new Error('Error al actualizar item');
          return refreshFLCartDrawer();
        })
        .catch(function(err) { console.error('Error al modificar carrito:', err); });
      }
    });

  }

  document.querySelectorAll('[data-fl-root]').forEach(initInstance);
})();